import { gateway } from '..';

export function rateFlashCardSet(id: number, rate: number, rateReasonId?: number, comment?: string) {
    return gateway
        .post<{
            success: true;
            user_star_vote: number;
            avg_star_score: number;
            ratings_count: number;
            has_voted: boolean;
        }>(`legacy-api/v1/flashcards/sets/${id}/rate`, {
            rate,
            comment,
            rate_reason_id: rateReasonId,
            origin: 1,
        })
        .then((response) => response.data);
}
